// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file user/v1/user.proto (package user.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Direction, PageRequest, PageResponse } from "../../tsam/v1/page_pb";
import { file_tsam_v1_page } from "../../tsam/v1/page_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user/v1/user.proto.
 */
export const file_user_v1_user: GenFile = /*@__PURE__*/
  fileDesc("ChJ1c2VyL3YxL3VzZXIucHJvdG8SB3VzZXIudjEiEwoRR2V0Q3VycmVudFJlcXVlc3QiMQoSR2V0Q3VycmVudFJlc3BvbnNlEhsKBHVzZXIYASABKAsyDS51c2VyLnYxLlVzZXIiGAoKR2V0UmVxdWVzdBIKCgJpZBgBIAEoCSIqCgtHZXRSZXNwb25zZRIbCgR1c2VyGAEgASgLMg0udXNlci52MS5Vc2VyIkwKBFNvcnQSHQoFZmllbGQYASABKA4yDi51c2VyLnYxLkZpZWxkEiUKCWRpcmVjdGlvbhgCIAEoDjISLnRzYW0udjEuRGlyZWN0aW9uIpwBCg1DcmVhdGVSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhIKCmZpcnN0X25hbWUYAiABKAkSEQoJbGFzdF9uYW1lGAMgASgJEhsKBHJvbGUYBCABKA4yDS51c2VyLnYxLlJvbGUSFgoJYWdlbmN5X2lkGAUgASgFSACIAQESEgoKY2Fpc3NlX2lkcxgGIAMoBUIMCgpfYWdlbmN5X2lkIi0KDkNyZWF0ZVJlc3BvbnNlEhsKBHVzZXIYASABKAsyDS51c2VyLnYxLlVzZXIifwoLTGlzdFJlcXVlc3QSIgoEcGFnZRgBIAEoCzIULnRzYW0udjEuUGFnZVJlcXVlc3QSIgoEc29ydBgCIAEoCzIULnVzZXIudjEuU29ydFJlcXVlc3QSKAoHZmlsdGVycxgDIAEoCzIXLnVzZXIudjEuRmlsdGVyc1JlcXVlc3QiqwEKDkZpbHRlcnNSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhIKCmZpcnN0X25hbWUYAiABKAkSEQoJbGFzdF9uYW1lGAMgASgJEiAKBHJvbGUYBCABKA4yDS51c2VyLnYxLlJvbGVIAIgBARIWCglhZ2VuY3lfaWQYBSABKAVIAYgBARISCgpjYWlzc2VfaWRzGAYgAygFQgcKBV9yb2xlQgwKCl9hZ2VuY3lfaWQiUQoMTGlzdFJlc3BvbnNlEhwKBXVzZXJzGAEgAygLMg0udXNlci52MS5Vc2VyEiMKBHBhZ2UYAiABKAsyFS50c2FtLnYxLlBhZ2VSZXNwb25zZSJTCgtTb3J0UmVxdWVzdBIdCgVmaWVsZBgBIAEoDjIOLnVzZXIudjEuRmllbGQSJQoJZGlyZWN0aW9uGAIgASgOMhIudHNhbS52MS5EaXJlY3Rpb24icgoNVXBkYXRlUmVxdWVzdBIKCgJpZBgBIAEoCRIbCgRyb2xlGAIgASgOMg0udXNlci52MS5Sb2xlEhYKCWFnZW5jeV9pZBgDIAEoBUgAiAEBEhIKCmNhaXNzZV9pZHMYBCADKAVCDAoKX2FnZW5jeV9pZCItCg5VcGRhdGVSZXNwb25zZRIbCgR1c2VyGAEgASgLMg0udXNlci52MS5Vc2VyIhEKD0ZvcmdldE1lUmVxdWVzdCISChBGb3JnZXRNZVJlc3BvbnNlIt4BCgRVc2VyEgoKAmlkGAEgASgJEg0KBWVtYWlsGAIgASgJEhIKCmZpcnN0X25hbWUYAyABKAkSEQoJbGFzdF9uYW1lGAQgASgJEhsKBHJvbGUYBSABKA4yDS51c2VyLnYxLlJvbGUSFgoJYWdlbmN5X2lkGAYgASgFSACIAQESEgoKY2Fpc3NlX2lkcxgHIAMoBRIYCgthZ2VuY3lfbmFtZRgIIAEoCUgBiAEBEhMKC2NhaXNzZV9uYW1lGAkgAygJQgwKCl9hZ2VuY3lfaWRCDgoMX2FnZW5jeV9uYW1lKmoKBUZpZWxkEhUKEUZJRUxEX1VOU1BFQ0lGSUVEEAASDwoLRklFTERfRU1BSUwQARIUChBGSUVMRF9GSVJTVF9OQU1FEAISEwoPRklFTERfTEFTVF9OQU1FEAMSDgoKRklFTERfUk9MRRAEKm0KBFJvbGUSFAoQUk9MRV9VTlNQRUNJRklFRBAAEg0KCVJPTEVfVVNFUhABEhkKFVJPTEVfQ0FJU1NFX0FTU09DSUFURRACEhUKEVJPTEVfVFJBVkVMX0FHRU5UEAMSDgoKUk9MRV9BRE1JThAEMv4CCgtVc2VyU2VydmljZRJHCgpHZXRDdXJyZW50EhoudXNlci52MS5HZXRDdXJyZW50UmVxdWVzdBobLnVzZXIudjEuR2V0Q3VycmVudFJlc3BvbnNlIgASMgoDR2V0EhMudXNlci52MS5HZXRSZXF1ZXN0GhQudXNlci52MS5HZXRSZXNwb25zZSIAEjUKBExpc3QSFC51c2VyLnYxLkxpc3RSZXF1ZXN0GhUudXNlci52MS5MaXN0UmVzcG9uc2UiABI7CgZDcmVhdGUSFi51c2VyLnYxLkNyZWF0ZVJlcXVlc3QaFy51c2VyLnYxLkNyZWF0ZVJlc3BvbnNlIgASOwoGVXBkYXRlEhYudXNlci52MS5VcGRhdGVSZXF1ZXN0GhcudXNlci52MS5VcGRhdGVSZXNwb25zZSIAEkEKCEZvcmdldE1lEhgudXNlci52MS5Gb3JnZXRNZVJlcXVlc3QaGS51c2VyLnYxLkZvcmdldE1lUmVzcG9uc2UiAGIGcHJvdG8z", [file_tsam_v1_page]);

/**
 * @generated from message user.v1.GetCurrentRequest
 */
export type GetCurrentRequest = Message<"user.v1.GetCurrentRequest"> & {
};

/**
 * Describes the message user.v1.GetCurrentRequest.
 * Use `create(GetCurrentRequestSchema)` to create a new message.
 */
export const GetCurrentRequestSchema: GenMessage<GetCurrentRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 0);

/**
 * @generated from message user.v1.GetCurrentResponse
 */
export type GetCurrentResponse = Message<"user.v1.GetCurrentResponse"> & {
  /**
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message user.v1.GetCurrentResponse.
 * Use `create(GetCurrentResponseSchema)` to create a new message.
 */
export const GetCurrentResponseSchema: GenMessage<GetCurrentResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 1);

/**
 * @generated from message user.v1.GetRequest
 */
export type GetRequest = Message<"user.v1.GetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message user.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 2);

/**
 * @generated from message user.v1.GetResponse
 */
export type GetResponse = Message<"user.v1.GetResponse"> & {
  /**
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message user.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 3);

/**
 * @generated from message user.v1.Sort
 */
export type Sort = Message<"user.v1.Sort"> & {
  /**
   * Field to sort by
   *
   * @generated from field: user.v1.Field field = 1;
   */
  field: Field;

  /**
   * Sort direction
   *
   * @generated from field: tsam.v1.Direction direction = 2;
   */
  direction: Direction;
};

/**
 * Describes the message user.v1.Sort.
 * Use `create(SortSchema)` to create a new message.
 */
export const SortSchema: GenMessage<Sort> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 4);

/**
 * @generated from message user.v1.CreateRequest
 */
export type CreateRequest = Message<"user.v1.CreateRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: user.v1.Role role = 4;
   */
  role: Role;

  /**
   * @generated from field: optional int32 agency_id = 5;
   */
  agencyId?: number;

  /**
   * @generated from field: repeated int32 caisse_ids = 6;
   */
  caisseIds: number[];
};

/**
 * Describes the message user.v1.CreateRequest.
 * Use `create(CreateRequestSchema)` to create a new message.
 */
export const CreateRequestSchema: GenMessage<CreateRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 5);

/**
 * @generated from message user.v1.CreateResponse
 */
export type CreateResponse = Message<"user.v1.CreateResponse"> & {
  /**
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message user.v1.CreateResponse.
 * Use `create(CreateResponseSchema)` to create a new message.
 */
export const CreateResponseSchema: GenMessage<CreateResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 6);

/**
 * @generated from message user.v1.ListRequest
 */
export type ListRequest = Message<"user.v1.ListRequest"> & {
  /**
   * @generated from field: tsam.v1.PageRequest page = 1;
   */
  page?: PageRequest;

  /**
   * @generated from field: user.v1.SortRequest sort = 2;
   */
  sort?: SortRequest;

  /**
   * @generated from field: user.v1.FiltersRequest filters = 3;
   */
  filters?: FiltersRequest;
};

/**
 * Describes the message user.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 7);

/**
 * @generated from message user.v1.FiltersRequest
 */
export type FiltersRequest = Message<"user.v1.FiltersRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;

  /**
   * @generated from field: optional user.v1.Role role = 4;
   */
  role?: Role;

  /**
   * @generated from field: optional int32 agency_id = 5;
   */
  agencyId?: number;

  /**
   * @generated from field: repeated int32 caisse_ids = 6;
   */
  caisseIds: number[];
};

/**
 * Describes the message user.v1.FiltersRequest.
 * Use `create(FiltersRequestSchema)` to create a new message.
 */
export const FiltersRequestSchema: GenMessage<FiltersRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 8);

/**
 * @generated from message user.v1.ListResponse
 */
export type ListResponse = Message<"user.v1.ListResponse"> & {
  /**
   * @generated from field: repeated user.v1.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: tsam.v1.PageResponse page = 2;
   */
  page?: PageResponse;
};

/**
 * Describes the message user.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 9);

/**
 * @generated from message user.v1.SortRequest
 */
export type SortRequest = Message<"user.v1.SortRequest"> & {
  /**
   * Field to sort by
   *
   * @generated from field: user.v1.Field field = 1;
   */
  field: Field;

  /**
   * Sort direction
   *
   * @generated from field: tsam.v1.Direction direction = 2;
   */
  direction: Direction;
};

/**
 * Describes the message user.v1.SortRequest.
 * Use `create(SortRequestSchema)` to create a new message.
 */
export const SortRequestSchema: GenMessage<SortRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 10);

/**
 * @generated from message user.v1.UpdateRequest
 */
export type UpdateRequest = Message<"user.v1.UpdateRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: user.v1.Role role = 2;
   */
  role: Role;

  /**
   * @generated from field: optional int32 agency_id = 3;
   */
  agencyId?: number;

  /**
   * @generated from field: repeated int32 caisse_ids = 4;
   */
  caisseIds: number[];
};

/**
 * Describes the message user.v1.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema: GenMessage<UpdateRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 11);

/**
 * @generated from message user.v1.UpdateResponse
 */
export type UpdateResponse = Message<"user.v1.UpdateResponse"> & {
  /**
   * @generated from field: user.v1.User user = 1;
   */
  user?: User;
};

/**
 * Describes the message user.v1.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema: GenMessage<UpdateResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 12);

/**
 * @generated from message user.v1.ForgetMeRequest
 */
export type ForgetMeRequest = Message<"user.v1.ForgetMeRequest"> & {
};

/**
 * Describes the message user.v1.ForgetMeRequest.
 * Use `create(ForgetMeRequestSchema)` to create a new message.
 */
export const ForgetMeRequestSchema: GenMessage<ForgetMeRequest> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 13);

/**
 * @generated from message user.v1.ForgetMeResponse
 */
export type ForgetMeResponse = Message<"user.v1.ForgetMeResponse"> & {
};

/**
 * Describes the message user.v1.ForgetMeResponse.
 * Use `create(ForgetMeResponseSchema)` to create a new message.
 */
export const ForgetMeResponseSchema: GenMessage<ForgetMeResponse> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 14);

/**
 * @generated from message user.v1.User
 */
export type User = Message<"user.v1.User"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: user.v1.Role role = 5;
   */
  role: Role;

  /**
   * @generated from field: optional int32 agency_id = 6;
   */
  agencyId?: number;

  /**
   * @generated from field: repeated int32 caisse_ids = 7;
   */
  caisseIds: number[];

  /**
   * @generated from field: optional string agency_name = 8;
   */
  agencyName?: string;

  /**
   * @generated from field: repeated string caisse_name = 9;
   */
  caisseName: string[];
};

/**
 * Describes the message user.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_user_v1_user, 15);

/**
 * @generated from enum user.v1.Field
 */
export enum Field {
  /**
   * @generated from enum value: FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIELD_EMAIL = 1;
   */
  EMAIL = 1,

  /**
   * @generated from enum value: FIELD_FIRST_NAME = 2;
   */
  FIRST_NAME = 2,

  /**
   * @generated from enum value: FIELD_LAST_NAME = 3;
   */
  LAST_NAME = 3,

  /**
   * @generated from enum value: FIELD_ROLE = 4;
   */
  ROLE = 4,
}

/**
 * Describes the enum user.v1.Field.
 */
export const FieldSchema: GenEnum<Field> = /*@__PURE__*/
  enumDesc(file_user_v1_user, 0);

/**
 * @generated from enum user.v1.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: ROLE_CAISSE_ASSOCIATE = 2;
   */
  CAISSE_ASSOCIATE = 2,

  /**
   * @generated from enum value: ROLE_TRAVEL_AGENT = 3;
   */
  TRAVEL_AGENT = 3,

  /**
   * @generated from enum value: ROLE_ADMIN = 4;
   */
  ADMIN = 4,
}

/**
 * Describes the enum user.v1.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_user_v1_user, 1);

/**
 * @generated from service user.v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc user.v1.UserService.GetCurrent
   */
  getCurrent: {
    methodKind: "unary";
    input: typeof GetCurrentRequestSchema;
    output: typeof GetCurrentResponseSchema;
  },
  /**
   * @generated from rpc user.v1.UserService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * @generated from rpc user.v1.UserService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * @generated from rpc user.v1.UserService.Create
   */
  create: {
    methodKind: "unary";
    input: typeof CreateRequestSchema;
    output: typeof CreateResponseSchema;
  },
  /**
   * @generated from rpc user.v1.UserService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateRequestSchema;
    output: typeof UpdateResponseSchema;
  },
  /**
   * @generated from rpc user.v1.UserService.ForgetMe
   */
  forgetMe: {
    methodKind: "unary";
    input: typeof ForgetMeRequestSchema;
    output: typeof ForgetMeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_user_v1_user, 0);

